import * as MutationTypes from '../mutationTypes';

export const resetPointOfSaleData = async ({ commit }) => {
  commit(MutationTypes.RESET_POINT_OF_SALE_STATE);
};
